import { render, staticRenderFns } from "./InstructorRequestedBookings.vue?vue&type=template&id=4f606e2d&scoped=true"
import script from "./InstructorRequestedBookings.vue?vue&type=script&lang=js"
export * from "./InstructorRequestedBookings.vue?vue&type=script&lang=js"
import style0 from "./InstructorRequestedBookings.vue?vue&type=style&index=0&id=4f606e2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f606e2d",
  null
  
)

export default component.exports